import React from 'react';
import './UserName.less';

export const UserName = ({text, isClickable}) => {
	return <h2 className={`user-name ${
		isClickable ? 'user-name--clickable' : ''
	}`}>
		{text}
	</h2>;
};
